// extracted by mini-css-extract-plugin
export default {"terms":"QfQE5Fpi710p15HCbew2"};